import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app.jsx';
import { AuthProvider } from './comum/Context/auth';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
